export const RES_CONFIG_KEY = {
    promotionCountry: 'promotionCountry',
    clinics: 'clinics',
    groups: 'groups',
    admin_group: 'admin_group',
    distr_groups: 'distr_groups',
    acc_distr_groups: 'acc_distr_groups',
    form_download: 'form_download',
    knowledge_base: 'knowledge_base',
};
